<template>
  <div class="py-3">
    <div class="d-flex align-items-center">
      <font-awesome-icon icon="exclamation-triangle" size="lg" class="mr-4" />
      <div class="d-flex flex-column">
        <h6 class="mb-0">{{ error.message }}</h6>
      </div>
      <b-button class="text-muted ml-auto bg-transparent border-0" @click="$emit('close-toast')">
        <font-awesome-icon icon="times" />
      </b-button>
    </div>
  </div>
</template>

<i18n>
{
  "en": {
    "expand": "Press here to see more details",
    "errorCode": "Error code:",
    "date": "Date:",
    "reference": "Reference ID:",
    "message": "Error message:",
    "additionalInformation": "Additional information:",
    "errors": {
      "default": "An unknown error occurred"
    }
  },
   "da": {
    "expand": "Klik her for at se flere detajler",
    "errorCode": "Fejlkode:",
    "date": "Dato:",
    "reference": "Reference ID:",
    "message": "Fejlbesked:",
    "additionalInformation": "Yderligere information:",
    "errors": {
      "default": "Der skete en ukendt fejl"
    }
   }
}
</i18n>

<script>
  import getStartingLocale from '@/locales/utils/getStartingLocale';
  import Vue from 'vue';

  // This component is written using pure javascript, and options api due to annoying il8n errors and incompatilibies with vue 2.0.

  export default Vue.extend({
    props: {
      error: {
        type: Object,
        required: false
      }
    },
    data: function () {
      return {
        expanded: false
      };
    },
    computed: {
      errorTitle: function () {
        switch (this.$props.error?.errorCode) {
          case 1:
            return 'errors.1';
          case 2:
            return 'errors.2';
          case 3:
            return 'errors.3';
          case 4:
            return 'errors.4';
          case 5:
            return 'errors.5';
          case 6:
            return 'errors.6';
          case 7:
          case 10:
            return 'errors.10';
          case 11:
            return 'errors.11';
          case 12:
            return 'errors.12';
          case 400:
            return 'errors.400';
          case 401:
            return 'errors.401';
          case 403:
            return 'errors.403';
          default:
            return 'errors.default';
        }
      }
    },
    created: function () {
      this.$i18n.locale = getStartingLocale();
    }
  });
</script>
